<!--隐私协议-->
<template>
    <div class="download">
        <div class="container">
            <div class="ayz_logo"><img src="/download/white_logo.png" alt="爱驿站"></div>
            <div class="title">
                共建信任 &nbsp;&nbsp; 服务社会
            </div>
            <div class="ayz_app"><img src="/download/ayz_app.png" alt="爱驿站"></div>
            <div class="download_button">
                <div class="button_text" @click="goDownLoad">
                    立即下载
                </div>
            </div>

        </div>

    </div>
    <div class="footer">
        <p>江苏爱驿站信息科技有限公司</p>
        <p>Copyright © 2014-2025 Aiyizhan All Rights Reserved</p>
    </div>

    <van-overlay :show="show" @click="show = false">
        <div class="wrapper" @click.stop>
            <div class="block">
                <img class="arrow_mark" src="/download/arrow_mark.png" alt="爱驿站">
                <div class="arrow_text">
                    点击右上角选择“在浏览器中打开”
                </div>
            </div>
        </div>
    </van-overlay>

</template>

<script>

import ayzAjax from "@/plugins/axios";
import {isWeiXin, downFile, isIOS} from "@/assets/js/common";
import {showFailToast, showLoadingToast} from "vant";

export default {
    name: "DownloadView",
    data: function () {
        return {
            show:false,
            loading:false,
            download_msg:'',
            download_url:'',
            download_apk_name:'',
        }
    },
    created() {
        this.getAppVersion();
    },
    methods: {
        async goDownLoad(){
            if(isWeiXin()){
                this.show = true;
                return false;
            }
            if (isIOS()){
                window.location.href = 'https://itunes.apple.com/cn/app/id6738973583?mt=8';
                return false;
            }
            if (this.download_msg !== ""){
                showFailToast(this.download_msg);
                return false;
            }

            if (this.loading){
                return false;
            }
            this.loading = true;
            showLoadingToast({
                message: '加载中...',
                forbidClick: true,
            });
            downFile(this.download_url,this.download_apk_name);
            return false;
        },

        getAppVersion(){
            ayzAjax.get('/get_app_version').then((response) => {
                if(response.data.code !== 200){
                    this.download_msg = response.data.msg;
                    // showFailToast(this.download_msg);
                    return false;
                }
                this.download_url = response.data.data.download_url;
                let urlArr = this.download_url.split('/');
                let apkName = urlArr[urlArr.length - 1];
                this.download_apk_name = apkName.endsWith('.apk') ? apkName : apkName + '.apk';
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.download{
    display: flex;
    width: 100%;
    height: 800px;
    justify-content: center; /* 水平居中 */
    align-items: center;
    background-image: url('~@/assets/download-background.png');
    background-size: cover;
    //background-size: contain;
    background-repeat: no-repeat;

    .container{
        min-height: 500px;
        width: 100%;
        margin: 10px 10px 20px 10px;
        padding: 10px 10px 80px 10px;
        text-align: left;
        border-radius: 10px;
        .ayz_logo{
            display: flex;
            justify-content: center; /* 水平居中 */
            align-items: center;
            margin-top: 25px;
            margin-bottom: 25px;
            img{
                width: 150px;
            }
        }
        .title{
            text-align: center;
            color: #fff;
            font-size: 22px;
        }
        .ayz_app{
            display: flex;
            justify-content: center; /* 水平居中 */
            align-items: center;
            margin-top: 50px;
            //margin-bottom: 30px;
            img{
                width: 209px;
                height: 310px;
            }
        }

        .download_button{
            margin-top: 30px;
            //padding-top: 20px;
            display: flex;
            justify-content: center; /* 水平居中 */
            align-items: center;
            .button_text{
                width: 170px;
                height: 50px;
                color: #fff;
                text-align: center;
                border: #F6F6F6 1px solid;
                border-radius: 25px;
                line-height: 50px;
            }
        }

    }
}
.footer{
    margin-top: -80px;
    text-align: center;
    color: #A5A5A5;
    font-weight: 300;
    font-size: 13px;
}

.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #F8F8F8;
    font-size: 13px;
    .block {
        width: 100%;
        height: 100%;
        text-align: center;
        padding-right: 20px;
        padding-top: 40px;
        .arrow_mark{
            width: 75px;
            height: 102px;
            float: right;
        }
        .arrow_text{
            width: 100%;
            margin-top: 120px;
            text-align: center;
            font-size: 18px;
        }
    }

}


</style>
